import { TDateAppFormat } from '@/domains/types';

// eslint-disable-next-line no-restricted-imports
import dayjs from '../dayjsConfig';

const isDayjsGuard = (
  date: unknown,
): date is TDateAppFormat => dayjs.isDayjs(date);

export default isDayjsGuard;
